<template>
  <div v-if="changes.length" class="daily-changes">
    <strong>为什么变化 <span v-if="unread.length">· {{ unread.length }} 条未读</span></strong>
    <ul><li v-for="change in visibleChanges" :key="change.id">
      <span v-if="change.trade_date !== digestDate">{{ change.trade_date }} · </span>{{ change.summary }}
      <small v-if="change.alert_count > 1">已合并{{ change.alert_count }}条</small>
    </li></ul>
    <div class="change-actions">
      <button v-if="changes.length > 3" type="button" @click="expanded = !expanded">{{ expanded ? '收起' : `还有${remainingCount}条` }}</button>
      <button v-if="unread.length" type="button" :disabled="saving" @click="markRead">{{ saving ? '保存中…' : '标为已读' }}</button>
    </div>
    <p v-if="error" role="alert">{{ error }}</p>
  </div>
</template>

<script>
import { request_zzquant } from '@/network/request'
export default {
  name: 'TopicDailyChanges',
  props: { changes: { type: Array, default: () => [] }, digestDate: String },
  data() { return { saving: false, error: '', expanded: false } },
  computed: {
    unread() { return this.changes.filter(change => !change.is_read) },
    visibleChanges() { return this.expanded ? this.changes : this.changes.slice(0, 3) },
    remainingCount() { return Math.max(0, this.changes.length - 3) },
    unreadIds() {
      return [...new Set(this.unread.reduce((ids, change) => {
        const alertIds = Array.isArray(change.unread_alert_ids) ? change.unread_alert_ids : [change.id]
        return ids.concat(alertIds.filter(id => id !== null && id !== undefined))
      }, []))]
    }
  },
  methods: {
    async markRead() {
      this.saving = true
      this.error = ''
      const ids = this.unreadIds
      try {
        for (let offset = 0; offset < ids.length; offset += 1000) {
          const response = await request_zzquant({ url: '/v3/topic/follow-alerts/read', method: 'POST', noRedirect: true, data: { alert_ids: ids.slice(offset, offset + 1000) } })
          if (!response || !response.data || response.data.code !== 20000) throw new Error('read failed')
        }
        this.$emit('read', ids)
        this.$root.$emit('topic-follow-alerts-read', ids)
      } catch (e) { this.error = '标记失败，请重试。' } finally { this.saving = false }
    }
  }
}
</script>

<style scoped>
.daily-changes { margin:8px 0; padding:8px; border-left:2px solid #c08045; background:var(--bg-muted, #f5f7fa); font-size:11px; line-height:1.5; }
.daily-changes strong { font-size:11px; }
.daily-changes ul { padding-left:15px; margin:5px 0; max-height:160px; overflow:auto; }
.daily-changes li small { margin-left:5px; color:var(--text-muted, #718096); white-space:nowrap; }
.change-actions { display:flex; align-items:center; justify-content:space-between; gap:8px; }
.daily-changes button { border:0; background:none; color:var(--text-primary, #47749e); padding:0; cursor:pointer; }
.daily-changes p { margin:4px 0 0; }
</style>
